export function deduplicateArrayByKey(
  arr,
  keys,
) {
  const seen = new Set()
  return arr.filter((item) => {
    const value = keys.map((key) => item[key]).join('__dedup__')
    if (seen.has(value)) {
      return false
    } else {
      seen.add(value)
      return true
    }
  })
}

export function isSameArray(arr1, arr2) {
  if (arr1.length !== arr2.length) return false
  const sorted1 = [...arr1].sort()
  const sorted2 = [...arr2].sort()

  return sorted1.every((value, index) => value === sorted2[index])
}

export function removeAllValue(arr, value) {
  return arr.filter(item => item !== value)
}
